export const edgesToNode = (edges) => edges.map(({ node }) => node)
